<div class="invite-page">

  <!-- Loader -->
  <div class="invite-card" *ngIf="pageLoader">
    <div class="loader-state">
      <div class="spinner"></div>
      <p class="loader-text">Loading invitation...</p>
    </div>
  </div>

  <!-- Not Found / Error -->
  <div class="invite-card" *ngIf="!pageLoader && notFound">
    <div class="status-icon error-icon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10" />
        <line x1="15" y1="9" x2="9" y2="15" />
        <line x1="9" y1="9" x2="15" y2="15" />
      </svg>
    </div>
    <h2 class="status-title">{{ errorMessage || 'Invitation not found.' }}</h2>
    <p class="status-subtitle">The link may be invalid or expired.</p>
    <button class="btn-secondary" (click)="goToDashboard()">Go to Dashboard</button>
  </div>

  <!-- Post-Accept Success -->
  <div class="invite-card success-card" *ngIf="!pageLoader && !notFound && accepted">
    <div class="status-icon success-icon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
        <circle cx="12" cy="12" r="10" />
        <polyline points="9,12 11,14 15,10" />
      </svg>
    </div>
    <h2 class="status-title" style="color:#059669">App Installed Successfully</h2>
    <p class="status-subtitle">
      <strong>{{ invitation?.appName }}</strong> has been added to
      <strong>{{ invitation?.businessName }}</strong>.
    </p>
    <div class="action-row">
      <button class="btn-primary" (click)="goToApps()">Open Apps</button>
      <button class="btn-secondary" (click)="goToDashboard()">Go to Dashboard</button>
    </div>
  </div>

  <!-- Main Invitation Card -->
  <div class="invite-card" *ngIf="!pageLoader && !notFound && !accepted && invitation">

    <!-- App Header -->
    <div class="app-logo-wrap">
      <img *ngIf="invitation.appImage" [src]="invitation.appImage" [alt]="invitation.appName" class="app-logo"
        (error)="invitation.appImage = ''" />
      <div class="app-logo-placeholder" *ngIf="!invitation.appImage">
        {{ invitation.appName.charAt(0) || '?' }}
      </div>
    </div>

    <h2 class="app-name">{{ invitation.appName }}</h2>

    <!-- appDescription is optional in the API response -->
    <p class="app-desc" *ngIf="invitation.appDescription">
      {{ invitation.appDescription }}
    </p>

    <div class="divider"></div>

    <!-- PENDING -->
    <ng-container *ngIf="invitation.status === 'PENDING'">
      <div class="invite-badge pending-badge">Invitation Pending</div>
      <p class="invite-message">You've been invited to install this application.</p>
      <div class="business-info">
        <span class="business-label">Business</span>
        <span class="business-name">{{ invitation.businessName }}</span>
      </div>
      <div class="error-banner" *ngIf="errorMessage">{{ errorMessage }}</div>
      <button class="btn-primary btn-full" [disabled]="!invitation.canAccept || accepting" (click)="acceptInvitation()">
        <span class="btn-spinner" *ngIf="accepting"></span>
        <span>{{ accepting ? 'Installing...' : 'Accept Invitation' }}</span>
      </button>
      <p class="disabled-hint" *ngIf="!invitation.canAccept && !accepting">
        This invitation is not available for acceptance.
      </p>
    </ng-container>

    <!-- ACCEPTED -->
    <ng-container *ngIf="invitation.status === 'ACCEPTED'">
      <div class="invite-badge accepted-badge">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2.5">
          <polyline points="20,6 9,17 4,12" />
        </svg>
        Installed
      </div>
      <p class="invite-message" style="color:#059669">
        Application already installed successfully.
      </p>
      <div class="business-info">
        <span class="business-label">Business</span>
        <span class="business-name">{{ invitation.businessName }}</span>
      </div>
      <button class="btn-primary btn-full" (click)="goToDashboard()">Open Dashboard</button>
    </ng-container>

    <!-- CANCELLED -->
    <ng-container *ngIf="invitation.status === 'CANCELLED'">
      <div class="invite-badge cancelled-badge">Cancelled</div>
      <p class="invite-message" style="color:#dc2626">
        This invitation has been cancelled.
      </p>
      <div class="business-info">
        <span class="business-label">Business</span>
        <span class="business-name">{{ invitation.businessName }}</span>
      </div>
    </ng-container>

  </div>
</div>